import versionTariffication from './components/versionTariffication';

export default {
  routes: [
    {
      path: '/',
      component:versionTariffication,
      name:'versionTariffication'
    },
  ]
};